import PropTypes from 'prop-types';
import { getBreakStatusDisplayData, getBreakSubtitleData } from '../../../utils/helpers/breaks/breakHelpers';
import { StatusText } from '../../shared/SharedStyles';
import { ShiftDetailRow, ShiftDetailsDivider, DetailLabelGroup, BreakItemContainer } from '../ShiftDetails.styles';
import { Typography } from '@mui/material';
import { useTimeFormatters } from '../../../utils/Hooks/venue/useVenueTimeFormatters';

const BreakDetails = ({ breakData }) => {
  const { formatTime, formatTimeRange } = useTimeFormatters();
  const breakStatusDisplayData = getBreakStatusDisplayData(breakData);
  const breakSubtitleData = getBreakSubtitleData(breakData, formatTime, formatTimeRange);

  return (
    <BreakItemContainer>
      <ShiftDetailRow>
        <DetailLabelGroup>
          <Typography variant="body2">{breakData.name}</Typography>
          <StatusText variant="caption" status={breakSubtitleData.breakStatus}>
            {breakSubtitleData.breakSubtitle}
          </StatusText>
        </DetailLabelGroup>
        <StatusText variant="body2" status={breakStatusDisplayData.status}>
          {breakStatusDisplayData.text}
        </StatusText>
      </ShiftDetailRow>
      <ShiftDetailsDivider />
    </BreakItemContainer>
  );
};

BreakDetails.propTypes = {
  breakItem: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  breakIndex: PropTypes.number.isRequired,
  isPastShift: PropTypes.bool.isRequired,
};

export default BreakDetails;
